module.exports = __webpack_public_path__ + "static/media/girls_boys.35e771a7.svg";